import { useState } from 'react';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { showToast } from '../components/ui/Toast';
import { useSiteContent } from '../context/SiteContentContext';

export default function AdminCareGuide() {
  const { content, updateBulk } = useSiteContent();
  const [form, setForm] = useState({ ...content });
  const [saved, setSaved] = useState(true);

  function set(key, value) { setForm(prev => ({ ...prev, [key]: value })); setSaved(false); }
  const [saving, setSaving] = useState(false);
  async function save() {
    if (saving) return;
    setSaving(true);
    const r = await updateBulk(form);
    setSaving(false);
    if (r && r.error) { showToast(r.error, 'error'); return; }
    setSaved(true);
    showToast('Care guide saved');
  }

  function field(key, label, type = 'input') {
    return (
      <div className="adm-field">
        <label className="adm-label">{label}</label>
        {type === 'textarea' ? (
          <textarea className="adm-textarea" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        ) : (
          <input className="adm-input" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        )}
      </div>
    );
  }

  return (
    <div>
      <h1 className="adm-title">Care guide</h1>
      <p className="adm-sub">Edit the four care cards, warning list, and FAQ answers.</p>

      {field('care_heading', 'Page heading')}

      {[1,2,3,4].map(n => (
        <div className="adm-card" key={n}>
          <div className="adm-card-title">Care card {n}</div>
          {field(`care_${n}_title`, 'Title')}
          {field(`care_${n}_frequency`, 'Frequency badge')}
          {field(`care_${n}_body`, 'Description', 'textarea')}
        </div>
      ))}

      <div className="adm-card">
        <div className="adm-card-title">What to avoid</div>
        {field('care_warning', 'Warning items (separate with | character)', 'textarea')}
      </div>

      {[1,2,3,4].map(n => (
        <div className="adm-card" key={n}>
          <div className="adm-card-title">FAQ {n}</div>
          {field(`care_faq_${n}_q`, 'Question')}
          {field(`care_faq_${n}_a`, 'Answer', 'textarea')}
        </div>
      ))}

      <div className="adm-save-bar">
        <span className={`adm-save-status ${saved ? 'adm-save-status--saved' : ''}`}>
          {saved ? '✓ All changes saved' : '● Unsaved changes'}
        </span>
        <button className="adm-btn" onClick={save}><IconDeviceFloppy size={14} /> Save</button>
      </div>
    </div>
  );
}
